export const translations = {
  en: {
    usernamePlaceholder: "Username",
    passwordPlaceholder: "Password",
    incorrectCredentials: "Incorrect credentials",
    forgotPassword: "Forgot password?",
    loginButton: "Log in",
  },
  cz: {
    usernamePlaceholder: "Uživatelské jméno",
    passwordPlaceholder: "Heslo",
    incorrectCredentials: "Nesprávné přihlašovací údaje",
    forgotPassword: "Zapomněli jste heslo?",
    loginButton: "Přihlásit se",
  },
  fr: {
    usernamePlaceholder: "Nom d'utilisateur",
    passwordPlaceholder: "Mot de passe",
    incorrectCredentials: "Identifiants incorrects",
    forgotPassword: "Mot de passe oublié ?",
    loginButton: "Se connecter",
  },
  ru: {
    usernamePlaceholder: "Имя пользователя",
    passwordPlaceholder: "Пароль",
    incorrectCredentials: "Неверные учетные данные",
    forgotPassword: "Забыли пароль?",
    loginButton: "Войти",
  },
  es: {
    usernamePlaceholder: "Nombre de usuario",
    passwordPlaceholder: "Contraseña",
    incorrectCredentials: "Credenciales incorrectas",
    forgotPassword: "¿Olvidaste tu contraseña?",
    loginButton: "Iniciar sesión",
  },
  nl: {
    usernamePlaceholder: "Gebruikersnaam",
    passwordPlaceholder: "Wachtwoord",
    incorrectCredentials: "Onjuiste gegevens",
    forgotPassword: "Wachtwoord vergeten?",
    loginButton: "Inloggen",
  },
  sk: {
    usernamePlaceholder: "Používateľské meno",
    passwordPlaceholder: "Heslo",
    incorrectCredentials: "Nesprávne prihlasovacie údaje",
    forgotPassword: "Zabudli ste heslo?",
    loginButton: "Prihlásiť sa",
  },
  de: {
    usernamePlaceholder: "Benutzername",
    passwordPlaceholder: "Passwort",
    incorrectCredentials: "Falsche Anmeldedaten",
    forgotPassword: "Passwort vergessen?",
    loginButton: "Anmelden",
  },
  hu: {
    usernamePlaceholder: "Felhasználónév",
    passwordPlaceholder: "Jelszó",
    incorrectCredentials: "Hibás hitelesítő adatok",
    forgotPassword: "Elfelejtette a jelszavát?",
    loginButton: "Bejelentkezés",
  },
  pl: {
    usernamePlaceholder: "Nazwa użytkownika",
    passwordPlaceholder: "Hasło",
    incorrectCredentials: "Nieprawidłowe dane logowania",
    forgotPassword: "Zapomniałeś hasła?",
    loginButton: "Zaloguj się",
  },
  sv: {
    usernamePlaceholder: "Användarnamn",
    passwordPlaceholder: "Lösenord",
    incorrectCredentials: "Felaktiga uppgifter",
    forgotPassword: "Glömt lösenord?",
    loginButton: "Logga in",
  },
  no: {
    usernamePlaceholder: "Brukernavn",
    passwordPlaceholder: "Passord",
    incorrectCredentials: "Feil legitimasjon",
    forgotPassword: "Glemt passord?",
    loginButton: "Logg inn",
  },
  da: {
    usernamePlaceholder: "Brugernavn",
    passwordPlaceholder: "Adgangskode",
    incorrectCredentials: "Forkerte legitimationsoplysninger",
    forgotPassword: "Glemt adgangskode?",
    loginButton: "Log ind",
  },
  fi: {
    usernamePlaceholder: "Käyttäjätunnus",
    passwordPlaceholder: "Salasana",
    incorrectCredentials: "Virheelliset tunnukset",
    forgotPassword: "Unohditko salasanasi?",
    loginButton: "Kirjaudu sisään",
  },
  ar: {
    usernamePlaceholder: "اسم المستخدم",
    passwordPlaceholder: "كلمة المرور",
    incorrectCredentials: "بيانات اعتماد غير صحيحة",
    forgotPassword: "هل نسيت كلمة المرور؟",
    loginButton: "تسجيل الدخول",
  },
};

export default translations;
